import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentSubscription } from '../subscription/state/controller';
import { AppStateTypes } from '../../store/appStateTypes';
import { AppDispatch } from '../../store/configureStore';

export const LavaReturnHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { token } = useSelector((state: AppStateTypes) => state.auth);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lava = params.get('lava');

    if (!lava) return;

    params.delete('lava');
    navigate({ search: params.toString() ? `?${params.toString()}` : '' }, { replace: true });

    if (lava === 'success' && token) {
      dispatch(fetchCurrentSubscription(token));
    }
  }, []);

  return null;
};
